import PropTypes from 'prop-types';
import Icon from "../../../Display/Icon/Icon";
import StatusToolTip from "./StatusToolTip";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAY_NAME = 'search-program-card__referrals';
function ReferralStatus(_ref) {
  let {
    status,
    uup459SupersetPhase2,
    receivingReferrals,
    providerLicensed,
    programId
  } = _ref;
  let iconColor = '';
  let iconName = 'IconElectronsArrow';
  let tooltip = '';
  const getReferralStatusDisplayText = () => {
    if (uup459SupersetPhase2) {
      if ("".concat(status).toLocaleLowerCase() !== 'off-platform referrals only') {
        if (!providerLicensed) return 'Receiving Off-Platform Referrals';
        if (receivingReferrals) return 'Receiving On-Platform Referrals';
        return "Not Receiving Referrals".concat(status ? ": ".concat(status) : '');
      }
      return 'Receiving Off-Platform Referrals';
    }
    if (providerLicensed) {
      if (receivingReferrals) {
        return 'Receiving Referrals';
      }
      return "Not Receiving Referrals".concat(status ? ": ".concat(status) : '');
    }
    return 'Out of Network Organization';
  };
  const referralStatusDisplayText = getReferralStatusDisplayText();
  switch (referralStatusDisplayText) {
    case 'Receiving Referrals':
    case 'Receiving On-Platform Referrals':
      iconColor = 'grass-green';
      iconName = 'CheckCircle';
      break;
    case "Not Receiving Referrals".concat(status ? ": ".concat(status) : ''):
      iconColor = 'red';
      iconName = 'TimesCircle';
      break;
    default:
      // Receiving Off-Platform Referrals
      // Out of Network Organization
      iconColor = 'action-blue';
      iconName = 'Electrons';
  }
  if (referralStatusDisplayText === 'Receiving On-Platform Referrals') {
    tooltip = 'This program is receiving referrals on the Unite Us Platform. When sending them a referral, they can use Unite Us to accept, reject, or forward it.';
  }
  if (referralStatusDisplayText === 'Receiving Off-Platform Referrals') {
    tooltip = 'This program is not receiving referrals via the Unite Us platform. When creating an off platform referral, you’ll need to contact the program directly to request services for your client.';
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "flex w-full",
    children: [/*#__PURE__*/_jsx(Icon, {
      icon: iconName,
      color: iconColor,
      className: "pr-1 ".concat(DISPLAY_NAME, "__icon")
    }), /*#__PURE__*/_jsx("span", {
      className: "align-middle font-medium-font",
      children: referralStatusDisplayText
    }), tooltip && /*#__PURE__*/_jsx(StatusToolTip, {
      programId: programId,
      description: "referral-status-tool-tip",
      toolTip: tooltip,
      className: "ml-1",
      tooltipPosition: "bottom"
    })]
  });
}
ReferralStatus.propTypes = {
  status: PropTypes.string,
  receivingReferrals: PropTypes.bool.isRequired,
  providerLicensed: PropTypes.bool.isRequired,
  programId: PropTypes.string.isRequired,
  uup459SupersetPhase2: PropTypes.bool
};
ReferralStatus.defaultProps = {
  uup459SupersetPhase2: false,
  status: null
};
export default ReferralStatus;
//# sourceMappingURL=ReferralStatus.js.map